import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import style from './ServiziTile.module.scss';
import TextField from '../../../../components/TextField/TextField';

function ServiziTile({ servizi, index, setFieldValue }) {
  return (
    <div className={clsx(style.servizio__tile)}>
      <div className={clsx(style.servizio__input)}>
        <h3 className={clsx(style.servizio__nome)}>{servizi.at(index).servizio}</h3>
        <TextField name="servizio" type="checkbox" className={clsx(style.servizio__box)} checked={servizi.at(index).attivo} onChange={() => setFieldValue(`servizi.${index}.attivo`, !servizi.at(index).attivo)} />
      </div>
    </div>
  );
}

ServiziTile.propTypes = {
  servizi: PropTypes.arrayOf(PropTypes.shape({
    servizio: PropTypes.string,
    attivo: PropTypes.bool,
  })).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};
export default ServiziTile;
